'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _gradation = require('../gradation');

exports.default = {
	gradation: _gradation.convenient,
	flavour: ['long_convenient', 'long'],
	units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
};
//# sourceMappingURL=default.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/modules/style/default.js
// module id = vmN9
// module chunks = 0